export default "<div class=\"scrolling-wrapper\">\n <!--  <card-categoria *ngFor=\"let card of cards\" [card]=\"card\"></card-categoria> -->\n</div>";